import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import CustomInputField from '../../common/CustomInputField';
import {  getPaidPackageList} from '../../api/login/Login';

function PackgesSearch({ setResetkey, setPage, initialValues , setIntialValues  }) {
    const [packageData, setPackageData] = useState([])
        const token = window.localStorage.getItem('userToken')
   const getPackageData = async () => {
        const res = await getPaidPackageList()
        setPackageData(res?.data) }  

        useEffect(()=>{
       getPackageData()
        },[])
  
function handleSubmitForm(values) {
  setIntialValues(values);
  setResetkey((pre)=>!pre)
  setPage(0)
  
}

const handleResetForm = (resetForm) => {
  const defaultValues = {
    package_id: '', 
  };
  resetForm({ values: defaultValues });
  setIntialValues(defaultValues);
   setResetkey((pre)=>!pre)
  setPage(0)
 
};


    return (
        <>
            <div className="row m-4">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body p-0">
                            <div className="table-responsive active-projects style-1">
                                <div className="tbl-caption tbl-caption-2">
                                    <h4 className="heading mb-0"><b>Package Sales Search</b></h4>
                                </div>
                                <Formik
                                    initialValues={initialValues}
                                    onSubmit={handleSubmitForm}
                                    className="tbl-captionn"
                                >
                                    {(formik) => {
                                        const {
                                            values,
                                            handleChange,
                                            handleSubmit,
                                            resetForm,
                                            errors,
                                            touched,
                                            handleBlur,
                                            isValid,
                                            dirty,
                                        } = formik;
                                        return (
                                            <form className="tbl-captionn" onSubmit={handleSubmit}>
                                                <div className="row">
                                                    {/* <div className="col-xl-4 mb-3">
                                                        <CustomInputField
                                                            type="date"
                                                            placeholder="Start Date"
                                                            name="startDate"
                                                            value={values.startDate}
                                                            hasError={errors.startDate && touched.startDate}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            errorMsg={errors.startDate}
                                                            id="startDate"
                                                        />
                                                    </div>
                                                    <div className="col-xl-4 mb-3">
                                                        <CustomInputField
                                                            type="date"
                                                            placeholder="End Date"
                                                            name="endDate"
                                                            value={values.endDate}
                                                            hasError={errors.endDate && touched.endDate}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            errorMsg={errors.endDate}
                                                            id="endDate"
                                                        />
                                                    </div> */}
                                                    <div className="col-xl-4 mb-3">

                                                        <select className="form-select" aria-label="Default select example" name="package_id"
                                                            value={values.package_id}
                                                            hasError={errors.package_id && touched.package_id}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}>
                                                            <option>Open this select Package</option>
                                                            {packageData && packageData?.map((item, index) => (
                                                                <option key={index} value={item._id}>{item.package_name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    {/* <div className="col-xl-4 mb-3">
                                                        <CustomInputField
                                                            type="text"
                                                            placeholder="Member Code"
                                                            name="member_code"
                                                            value={values.member_code}
                                                            hasError={errors.member_code && touched.member_code}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            errorMsg={errors.member_code}
                                                            id="member_code"
                                                        />
                                                    </div>
                                                    <div className="col-xl-4 mb-3">
                                                        <CustomInputField
                                                            type="text"
                                                            placeholder="Member Name"
                                                            name="name"
                                                            value={values.name}
                                                            hasError={errors.name && touched.name}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            errorMsg={errors.name}
                                                            id="name"
                                                        />
                                                    </div>
                                                   */}

                                                    <div className="col-lg-12 col-md-12">
                                                        <div className='d-flex justify-content-start'>
                                                            <button className="btn btn-primary pd-x-20 " type="submit">
                                                                <i className="fas fa-search"></i> Search
                                                            </button>
                                                            <button className="btn btn-secondary pd-x-20 " type="button" onClick={()=>handleResetForm(resetForm)}>
                                                                <i className="fas fa-refresh"></i> Reset
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        );
                                    }}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PackgesSearch;
